const formatWord = (str: string, maxCharWord: number, maxWords: number) => {
  const formatted = str && str.replace(/[^\w\s\'\#\$\%\&\/\(\)\=\¡\*\+\-\_\;\|\?\¿\!\"\.\,\@áéíóúüñ]+/gi, '');
  str = formatted && formatted.replace(/\s\s+|\n/g, ' ');
  let isOkMaxLetterInWord = true;
  let arrWords = str.split(/\s/g).filter(Boolean);
  arrWords = getWordsWithRules(arrWords, maxCharWord);
  for (let i = 0; i < arrWords.length; i++) {
    if (arrWords[i].length > maxCharWord) {
      isOkMaxLetterInWord = false;
    }
  }
  while (!isOkMaxLetterInWord) {
    isOkMaxLetterInWord = true;
    arrWords = getWordsWithRules(arrWords, maxCharWord);
    for (let i = 0; i < arrWords.length; i++) {
      if (arrWords[i].length > maxCharWord) {
        isOkMaxLetterInWord = isOkMaxLetterInWord && false;
      } else {
        isOkMaxLetterInWord = isOkMaxLetterInWord && true;
      }
    }
  }
  if (arrWords.length > maxWords) {
    return arrWords.splice(0, maxWords);
  } else {
    return arrWords;
  }
}

const getWordsWithRules = (words: string[], maxCharWord: number) => {
  let currentString = '';
  for (let i = 0; i < words.length; i++) {
    if (words[i].length > maxCharWord) {
      for (let j = 0; j < words[i].length; j++) {
        if ((j + 1) % maxCharWord === 0) {
          currentString = currentString + words[i][j] + ' ';
        } else {
          currentString = currentString + words[i][j];
        }
      }
    } else {
      currentString = currentString + words[i] + ' ';
    }
  }
  return currentString.split(/\s/g).filter(Boolean);
}

const getWordsWithRulesAndSpace = (words: string[], maxCharWord: number) => {
  let currentString = '';
  for (let i = 0; i < words.length; i++) {
    if (!/(\s+)/gi.test(words[i])) {
      if (words[i].length > maxCharWord) {
        for (let j = 0; j < words[i].length; j++) {
          if ((j + 1) % maxCharWord === 0) {
            currentString = currentString + words[i][j] + ' ';
          } else {
            currentString = currentString + words[i][j];
          }
        }
      }
      if (words[i].length <= maxCharWord) {
        currentString = currentString + words[i];
      }
    } else {
      currentString = currentString + words[i];
    }
  }
  return currentString.split(/(\s+)/gi).filter(Boolean);
}

export const normalizeDescription = (maxChardWord: number, maxWords: number) => (value: string, previousValue: string) => {
  let arrValue: string[] = previousValue && previousValue.split(' ');
  let words: string[] = formatWord(value, maxChardWord, maxWords);
  if (words && arrValue && words.length === arrValue.length && arrValue[arrValue.length - 1].length <= maxChardWord && arrValue.length < maxWords) {
    return value.replace(/\s\s+|\n/g, ' ').replace(/[^\w\s\'\#\$\%\&\/\(\)\=\¡\*\+\-\_\;\|\?\¿\!\"\.\,\@áéíóúüñ]+/gi, '');
  }
  return words.join(' ');
};

export const normalizeDescriptionFormWeb = () => (value: string) => {
  return value.replace(/[^'#$%&/()=¡*+-_;|?¿!".,@áéíóúüñ\w\s(\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa})]/giu, '')
};

export const formatWordWeb = (str: string, maxCharWord: number, maxWords: number) => {
  const formatted = str && str.replace(/[^\w\s\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}]/giu, '');
  let arrWords = formatted.split(/(\s+)/gi).filter(Boolean);

  arrWords = getWordsWithRulesAndSpace(arrWords, maxCharWord);
  console.log(arrWords, 'arrWro')

  const arrWordCount = arrWords.join('').split(/\s/g).filter(Boolean);

  if (arrWordCount.length > maxWords) {
    const arrFinal = [];
    const aux = arrWordCount.splice(0, maxWords);
    const auxArrWord = [...arrWords];

    while (aux && aux.length > 0) {
      for (let i = 0; i < auxArrWord.length; i++) {
        for (let j = 0; j < aux.length; j++) {
          const el = auxArrWord[i];
          arrFinal.push(el);
          if (auxArrWord[i] === aux[j]) {
            aux.shift();
            break;
          }
        }
      }
    }
    return arrFinal.join('');
  } else {
    return arrWords.join('');
  }
};

export const maxLength = max => value => {
  let currentValue;
  const result = value.length > max;

  if (result === false) {
    currentValue = value;
  }
  return currentValue;
};

export const formatPrice = (price: number) => {
  if (!price) {
    return '00.00';
  }
  return price.toFixed(2);
};

export const onlyNumbersWithoutZeroInitial = (value: string) => {
  if (/^0+/gi.test(value)) {
    return value.replace(/^0+/, '');
  }
  return value
          .replace(/\D/g, '')
          .replace(/([0-9])([0-9]{2})$/, '$1.$2')  
          .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ',')
};
